var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStep05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_46129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 48.4158C7 27.0478 24.331 9.7168 45.7069 9.7168C67.0828 9.7168 84.4138 27.0478 84.4138 48.4158C84.4138 69.7838 67.0828 87.1227 45.7069 87.1227C24.331 87.1227 7 69.7996 7 48.4158Z",
    fill: "#F2F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2681 30.6434C47.2681 24.6035 52.1646 19.707 58.2044 19.707C64.2442 19.707 69.1407 24.6035 69.1407 30.6434C69.1407 36.6832 64.2442 41.5797 58.2044 41.5797C52.1646 41.5797 47.2681 36.6832 47.2681 30.6434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1965 43.3466C51.1869 43.3466 45.4861 37.6459 45.4861 30.6362C45.4861 23.6266 51.1869 17.9258 58.1965 17.9258C65.2062 17.9258 70.9069 23.6266 70.9069 30.6362C70.9069 37.6459 65.2062 43.3466 58.1965 43.3466ZM58.1965 21.4819C53.1502 21.4819 49.0343 25.5899 49.0343 30.6441C49.0343 35.6983 53.1423 39.8063 58.1965 39.8063C63.2507 39.8063 67.3587 35.6983 67.3587 30.6441C67.3587 25.5899 63.2507 21.4819 58.1965 21.4819Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5937 46.4297H72.7993C79.6592 46.4297 85.2259 51.9885 85.2259 58.8563V85.7752H31.175V58.8563C31.175 51.9964 36.7339 46.4297 43.6016 46.4297H43.5937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2258 87.55H31.175C30.1973 87.55 29.4009 86.7536 29.4009 85.7759V58.8569C29.4009 51.0272 35.7719 44.6562 43.6015 44.6562H72.8072C80.6368 44.6562 87.0078 51.0272 87.0078 58.8569V85.7759C87.0078 86.7536 86.2114 87.55 85.2337 87.55H85.2258ZM32.9491 84.0018H83.4596V58.8569C83.4596 52.9827 78.6814 48.2044 72.8072 48.2044H43.6015C37.7273 48.2044 32.9491 52.9827 32.9491 58.8569V84.0018Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2374 85.7752H57.5027L51.4313 60.2676H13.166L19.2374 85.7752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5027 87.55H19.2373C18.4173 87.55 17.6998 86.9902 17.5105 86.1859L11.4392 60.6783C11.313 60.15 11.4392 59.5902 11.7704 59.1644C12.1094 58.7386 12.6219 58.4863 13.166 58.4863H51.4313C52.2513 58.4863 52.9689 59.0462 53.1581 59.8504L59.2295 85.358C59.3556 85.8863 59.2295 86.4461 58.8983 86.8719C58.5592 87.2977 58.0467 87.55 57.5027 87.55ZM20.6408 84.0018H55.2555L50.0278 62.0424H15.4053L20.633 84.0018H20.6408Z",
    fill: "#B3B8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.296 75.398H56.8954C55.9177 75.398 55.1213 74.6016 55.1213 73.6239C55.1213 72.6462 55.9177 71.8498 56.8954 71.8498H71.5219V61.4733C71.5219 60.4956 72.3183 59.6992 73.296 59.6992C74.2737 59.6992 75.0701 60.4956 75.0701 61.4733V73.6239C75.0701 74.6016 74.2737 75.398 73.296 75.398Z",
    fill: "#B3B8C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_46129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 77.8317,
    fill: "white",
    transform: "translate(7 9.7168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep05);
export default __webpack_public_path__ + "static/media/icon_step05.4bfc89f80467c397e8d5b950ba7fa578.svg";
export { ForwardRef as ReactComponent };